module.exports = __webpack_public_path__ + "img/door-contact-sm.1b043844.svg";